export function SetupResponsiveAuthentication(
    $rootScope,
    ResponsiveLayoutService
) {
    $rootScope.$on('$stateChangeSuccess', function(fromState, toState) {
        if (toState.name === 'authentication.two-factor-authentication-verification') {
            ResponsiveLayoutService.addResponsiveMetaTag();
        }

        if (fromState.name === 'authentication.two-factor-authentication-verification') {
            ResponsiveLayoutService.removeResponsiveMetaTag();
        }
    });
}
SetupResponsiveAuthentication.$inject = [
    '$rootScope',
    'ResponsiveLayoutService'
];
